var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backup"},[_vm._v(" 微信版本太低，请升级微信客户端重新访问。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }